export class InsertAdminFeeDTO {
  feeType: string = 'flat';
  feeValue: number = 0;
  startDate: any;
  endDate: any;
  isAlwaysValid: boolean = true;
}
